import { Variants, Transition } from 'motion/react';
import { getEnterValue, slideAxis, axisModifier, SlideTransitionProps } from './use-slide-transition';

export type SlideFadeTransitionResponse = {
  item: boolean;
  key: string;
  variants: Variants;
  transition: Transition;
};

export function useSlideFadeTransition({
  active,
  direction,
  distance = '10px',
  config = { type: 'spring', stiffness: 300, damping: 30 },
}: SlideTransitionProps): SlideFadeTransitionResponse {
  const variants: Variants = {
    hidden: {
      opacity: 0,
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${distance})`,
    },
    visible: {
      opacity: 1,
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${getEnterValue(distance)})`,
    },
    exit: {
      opacity: 0,
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${distance})`,
    },
  };

  return {
    item: active,
    key: active ? 'visible' : 'hidden',
    variants,
    transition: config,
  };
}
